'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
require('../../../../../aviary-core/dist/cjs/index.cjs');
var reactFontawesome = require('../../../react-fontawesome/react-fontawesome.cjs');
var Skeleton_web = require('../Skeleton/Skeleton.web.cjs');
var CircularIcon_web_styles = require('./CircularIcon.web.styles.cjs');
var index = require('../../../../../../_virtual/index.cjs');

/**
 * CircularIcon component used to emphasize an object in the layout hierarchy
 *
 * @scope: Web
 *
 */ const CircularIcon = ({ icon, Svg, size = "medium", backgroundColor = "system", isColorPreserved, isLoading = false, customCss, ...rest })=>{
    if (!icon && !Svg) return null;
    const iconStyles = [
        CircularIcon_web_styles.baseStyles,
        CircularIcon_web_styles.size[size],
        CircularIcon_web_styles.background[backgroundColor],
        !isColorPreserved && CircularIcon_web_styles.iconFillColor[backgroundColor],
        customCss
    ];
    const iconSizeMap = {
        xsmall: "xs",
        small: "1x",
        medium: "1x",
        large: "lg"
    };
    if (isLoading) {
        return /*#__PURE__*/ jsxRuntime.jsx(Skeleton_web.Skeleton, {
            isCircular: true,
            height: index.__exports.ICON_PIXEL_DIMENSIONS[size].height,
            width: index.__exports.ICON_PIXEL_DIMENSIONS[size].width
        });
    }
    const renderContent = ()=>{
        if (icon) {
            return /*#__PURE__*/ jsxRuntime.jsx(reactFontawesome.FontAwesomeIcon, {
                icon: icon,
                size: iconSizeMap[size]
            });
        }
        if (Svg) {
            return /*#__PURE__*/ jsxRuntime.jsx(Svg, {});
        }
    };
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: iconStyles,
        ...rest,
        children: renderContent()
    });
};

exports.CircularIcon = CircularIcon;
//# sourceMappingURL=CircularIcon.web.cjs.map
